<template>
    <v-row no-gutters>
        <v-col cols="12" lg="3">
            <form-table-row label="참조품번" cols="4" lg="6"> <v-text-field v-model="form.MODEL_CODE" v-bind="{ ...attrs }" /> </form-table-row>
        </v-col>
        <v-col cols="12" lg="auto"> <v-divider class="d-none d-lg-block" vertical /> <v-divider class="d-block d-lg-none" /> </v-col>
        <v-col cols="12" lg="3">
            <form-table-row label="참조품명" cols="4" lg="6"> <v-text-field v-model="form.MODEL_NAME" v-bind="{ ...attrs }" /> </form-table-row>
        </v-col>
        <v-col cols="12" xl="auto"> <v-divider class="d-none d-xl-block" vertical /> <v-divider class="d-block d-xl-none" /> </v-col>
        <v-col cols="12" lg="3">
            <form-table-row label="참조Rev." cols="4" lg="6"> <v-text-field v-model="form.REVISION" v-bind="{ ...attrs }" /> </form-table-row>
        </v-col>
        <v-col cols="12" xl="auto"> <v-divider class="d-none d-xl-block" vertical /> <v-divider class="d-block d-xl-none" /> </v-col>
        <v-col cols="12" lg="">
            <form-table-row label="참조Rank" cols="4" lg="6"> <v-text-field v-model="form.RANK" v-bind="{ ...attrs }" /> </form-table-row>
        </v-col>
    </v-row>
</template>

<script>
import FormTableRow from "@/components/console/dumb/form-table-row.vue";

export default {
    components: {
        FormTableRow,
    },
    props: {
        attrs: { type: Object, default: () => ({}) },
    },
};
</script>

<style>
</style>